import { Component } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import addComponentAnimation from '@swisslife/shared-ui/src/utils/animations/js/animations';

enum States {
	WithAnimation = 'o-fusion-widget--with-animation',
}

// The @Component decorator will connect the class with `data-g-name="FusionWidget"` elements.
@Component('FusionWidget')
export class FusionWidget extends GondelJqueryComponent {
	private controllers: any[] = Array();

	public async sync() {
		if (this.$ctx.hasClass(States.WithAnimation)) {
			this.controllers = await addComponentAnimation(this.$ctx);
		}
	}

	public stop() {
		if (this.$ctx.hasClass(States.WithAnimation)) {
			for (const controller of this.controllers) {
				controller.destroy(true);
			}
		}
	}
}
